// extracted by mini-css-extract-plugin
module.exports = {"segment":"_21620d3522--segment--vomvd","segment_group":"_21620d3522--segment_group--b3ona"};